import ElementGroups from "@ext/markdown/core/element/ElementGroups";

export const sourceCommentSchema = {
	group: `${ElementGroups.block} ${ElementGroups.listItemContent}`,
	atom: true,
	attrs: {
		text: { default: "" },
	},
};

export const inlineSourceCommentSchema = {
	group: "inline",
	inline: true,
	atom: true,
	attrs: {
		text: { default: "" },
	},
};
